import { useAxios } from '@Shared/composables/useAxios';
import { usePortalUri } from '@Shared/composables/usePortalUri';
import { PortalSettings } from '@Shared/types/portal/PortalSettings';
import { PortalRole } from '@Shared/types/portal/Role';

export async function getPortalSettings(): Promise<PortalSettings> {
  const uri = usePortalUri();
  const axios = useAxios();
  const response = await axios.get(`${uri}/api/settings`);
  return response.data as PortalSettings;
}

export const getRoles = async () => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  const response = await axios.post<{ roles: PortalRole[] }>(`${portalUri}/api/settings/roles`, {});
  return response.data;
};
